const errorUrl = (url: string) =>
  url.replace(/^\/api\//, '').replace(/\?.*/, '')

export class ApiError extends Error {
  detail?: any

  constructor({
    error,
    url,
    response,
    detail,
  }: {
    error?: any
    url: string
    response?: Response
    detail?: Record<string, any>
  }) {
    // Calling super with message doesn't work
    super()

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError)
    }

    // Simplify url for message.
    const path = errorUrl(url)

    this.message = error
      ? `${path} ${error.message || error}`
      : response
        ? `${path} ${response.status}`
        : path

    this.detail = {url}
    if (response) {
      this.detail.status = response.status
      this.detail.headers = Object.fromEntries(response.headers.entries())
    }
    if (detail) {
      Object.assign(this.detail, detail)
    }

    // https://github.com/rollbar/rollbar.js/pull/687
    this.name = 'ApiError'
  }
}
